import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import nombreAlojamiento from "../../../img/onboarding/nombra_alojamiento.jpg";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { useDispatchDominio } from "../../../hooks/useDispatchDominio";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { ButtonRegresar } from "../../../components/ButtonRegresar";
import { ButtonSiguiente } from "../../onboardingHotel/ButtonSiguiente";

export const NombreTourHotel = () => {
    const { id: id_casa, plan } = useAppSelector(
        (state) => state.landing_house.house
    );
    const dispatch = useAppDispatch();
    const { idCasa } = useParams();

    const [input, setInput] = useState({
        nombre: "",
        descripcion: "",
    });

    const navigate = useNavigate();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const getOneHabitacion = async () => {
        fetchAxiosToken({
            url: `/hoteles_tours/detalle/${idCasa}`,
        })
            .then((res) => {
                console.log(res);
                setInput(res);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        if (idCasa && Number(idCasa) > 0) getOneHabitacion();
    }, []);
    console.log("id_casa", id_casa);
    const handleSubmit = async () => {
        if (!input.nombre) {
            return Swal.fire({
                title: "Debes escoger un nombre válido",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }

        if (!input.descripcion)
            return Swal.fire({
                title: "Debes agregar una descripción",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });

        try {
            if (idCasa && Number(idCasa) > 0) {
                await fetchAxiosToken({
                    url: `/hoteles_tours/updateNombre/${idCasa}`,
                    method: "put",
                    body: {
                        nombre: input.nombre,
                        descripcion: input.descripcion,
                    },
                });

                console.log("habitacion actualizada");

                navigate(
                    `/dashboard-hotel/onboarding-tour/imagenes-tour/${idCasa}`
                );
            } else {
                const data = await fetchAxiosToken({
                    url: `/hoteles_tours`,
                    method: "post",
                    body: {
                        id_hotel: id_casa,
                        nombre: input.nombre,
                        descripcion: input.descripcion,
                    },
                });

                console.log("habitacion creada", data);

                navigate(
                    `/dashboard-hotel/onboarding-tour/imagenes-tour/${data.data.id}`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="flex flex-col h-screen grid-cols-2 lg:grid">
            <div className="block h-56 md:h-1/3 lg:h-auto bg-black/80">
                <div className="relative flex flex-col items-center justify-center h-full text-center lg:h-screen">
                    <img
                        src={nombreAlojamiento}
                        alt="nombreAlojamiento"
                        className="w-full h-full"
                    />
                    <div className="absolute top-0 w-full h-full bg-black opacity-40 "></div>
                    <div className="absolute top-0 flex flex-col items-center justify-center w-2/3 h-full 0">
                        <div className="text-2xl font-bold text-center text-white md:text-4xl 2xl:text-6xl ">
                            Escoge un nombre para el Tour
                        </div>

                        <div className="mt-5 text-lg text-center text-white md:text-xl 2xl:text-2xl md:mt-14 ">
                            ¡No te preocupes podrás cambiarlo más adelante!
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex flex-col justify-center h-screen p-3 text-center text-black bg-white">
                <ButtonRegresar
                    url={`${"/dashboard-hotel/habitaciones"}`}
                    className="absolute top-10 left-10"
                    arrowColor="black"
                    textColor="black"
                />
                <div className="flex flex-col items-start justify-center w-3/4 mx-auto md:w-2/3 lg:w-1/2">
                    <h2 className="text-xl font-medium md:text2xl lg:text-3xl">
                        Nombre
                    </h2>
                    <input
                        type={"text"}
                        name="nombre"
                        value={input.nombre}
                        onChange={handleInputChange}
                        placeholder="ej. Cataratas de Iguazu"
                        className="w-full p-3 mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />

                    <h2 className="mt-3 text-xl font-medium md:text2xl lg:text-3xl">
                        Descripción
                    </h2>
                    <div className="w-full p-2 mt-2 text-black border border-gray-500 rounded-lg">
                        <textarea
                            onChange={(e) =>
                                setInput({
                                    ...input,
                                    descripcion: e.target.value,
                                })
                            }
                            value={input.descripcion}
                            placeholder="ej. Una vez nos hayamos reunido en nuestro punto de encuentro y hayamos recopilado toda la información necesaria, nos dirigiremos al Parque Nacional de Argentina."
                            className="w-full h-20 text-sm bg-transparent border-none outline-none focus:outline-none 2xl:text-base placeholder:text-gray-400 placeholder:italic"
                        />
                    </div>

                    <ButtonSiguiente onSubmit={() => handleSubmit()} />
                </div>
            </div>
        </div>
    );
};
